<template>
    <div class="info-section">
        <!-- Text -->
        <div class="text">
            <div class="title-description">
                <div class="title-lines" ref="title">
                    <h1 class="title" v-html="data.title"></h1>
                    <div class="lines">
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <!-- Description -->
                <h3 class="description" ref="description" v-html="data.description"></h3>
                <!-- Show more Button -->
                <div class="container-button" ref="show_more_button">
                    <!-- Button -->
                    <div
                        v-if="data.button_link" 
                        class="show-more-button">
                        <router-link
                            v-if="data.button_link.type != 'ext'" 
                            tag="a" :to="{ name: data.button_link.link  }">
                            {{ data.buttonText || 'Saber Más' }}
                        </router-link>
                        <a v-else :href="data.button_link.link" target="_blank">
                            {{ data.buttonText || 'Saber Más' }}
                        </a>
                    </div>
                    <!-- Social networks -->
                    <div class="social-networks" v-if="data.social_networks">
                        <a href="https://www.linkedin.com/in/sebastian-b%C3%A1ez-a461a2176/" target="_blank" title="LinkedIn - Sebastian Báez">
                            <img src="@/assets/images/social-icons/linkedin-white.svg" alt="linkedin-white.svg">
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=573014577981&text=¡Hola Sebastian!%20¿cómo estás?" target="_blank" title="WhatsApp - 3014577981">
                            <img src="@/assets/images/social-icons/whatsapp-white.svg" alt="whatsapp-white.svg">
                        </a>
                        <a href="mailto:sebasbaezcode@gmail.com" target="_blank" title="Email - sebasbaezcode@gmail.com">
                            <img src="@/assets/images/social-icons/email-white.svg" alt="email-white.svg">

                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Image -->
        <div class="container-image"
             :class="{ 'container-image-full': data.type != 'home' }">
            <div
                v-if="data.image"
                :style="`background-image: url(${require(`@/assets/images/${data.image.url || 'bg.jpg'}`)})`"  
                class="image">
                <div class="bg-red" ref="bg_red"></div>
            </div>
        </div>
    </div>
</template>

<script>
// `
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
export default {
    props: ['data', 'render', 'leave'],
    data() {
        return {

        }
    },
    methods: {
        onRenderAnimations() {
            TweenLite.fromTo(this.$refs.bg_red, 0.9, 
               { left: '5%', width: '2%' },
               { left: '100%', width: '45%' }
            ).delay(1);
        },
        leaveAnimations() {
            let app = this;

            // Title Description
            TweenLite.to(this.$refs.title, 0.8,
                { css: { left: '-70%', opacity: 0 } },
            ).delay(0.1);

            TweenLite.to([this.$refs.description, this.$refs.show_more_button], 0.8,
                { css: { left: '-70%', opacity: 0 } }
            ).delay(0.2);
        },
        returnAnimations() {
            TweenLite.fromTo(this.$refs.bg_red, 0.9, 
               { left: '5%', width: '2%' },
               { left: '100%', width: '45%' }
            ).delay(0.2);
            
            // Title Description
            TweenLite.fromTo(this.$refs.title, 0.8,
                { css: { left: '-70%', opacity: 0 } },
                { css: { left: '0%', opacity: 1 } },
            ).delay(0.1);

            TweenLite.fromTo([this.$refs.description, this.$refs.show_more_button], 0.8,
                { css: { left: '-70%', opacity: 0 } },
                { css: { left: '0%', opacity: 1 } }
            ).delay(0.2); 
        }
    },
    watch: {
        render() {
            this.returnAnimations();                
        },
        leave() {
            this.leaveAnimations();
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import '@/assets/css/_mixins.scss';

.info-section {
    position: absolute;
    width: 100%;
    height: 100%;
    max-height: 100vh;

    // Text
    .text {
        width: 100%;

        .title-description {
            @extend %default-title;
            z-index: 2;

            .title-lines, .description { left: -3% }
            
            @media (min-width: 760px) {
                width: 80%;
                .title-lines, .description { left: 0% }
            }

            @media (min-width: 1024px) {
                .description {
                    max-width: 45%
                }
            }

            @media (min-width: 1900px) {
                .description { max-width: 40% }
            }
        }
        // Show more button
        .container-button {
            position: relative;
            text-align: center;
            height: auto;
            margin-top: 25px;

            .show-more-button {
                max-width: 200px;
                margin: auto;
                @include transition(all 0.4s);

                &:hover { @include transform(translate(0px, -3.5px)) }
                a {
                    background-color: $main-red-1;
                    border-radius: 50px;
                    padding: 10px 30px 10px 30px;
                    border: 1px solid $main-red-1;
                    font-size: 0.9rem;
                    color: #FFFFFF;
                    text-decoration: none;
                }
            }

            .social-networks {                
                a { 
                    @include transition(all 0.3s);
                    &:hover {
                        opacity: 0.6
                    }
                    img {
                        width: 35px; 
                        margin-right: 20px;
                    }
                    &:last-child {
                        img { margin-right: 0px }  
                    }
                }
            }

            @media (min-width: 760px) {
                margin-top: 40px;
                width: 50%;
                margin-left: 7%;
                .show-more-button { margin: 0px 0px 0px 15px }
            }

            @media (min-width: 1024px) {
                margin-top: 55px;
                .show-more-button {
                     a {
                        padding: 15px 32px 15px 32px;
                        font-size: 1rem;
                    }
                }

                .social-networks {
                    text-align: left;   
                    margin-left: 7%;
                    a { 
                        img { width: 40px }
                    }               
                }
            }

            @media (min-width: 1200px) {
                .social-networks {
                    a { 
                        img { width: 45px }
                    }               
                }
            }

            @media (min-width: 1900px) {
                margin-top: 70px;

                .social-networks {
                    a { 
                        img { width: 50px }
                    }               
                }
            }
        }
    }

    //Image
    .container-image-full {
        top: 0% !important;
        height: 63% !important;

        .image { 
            width: 100% !important;
            animation: algo 2s;
        }
        @media (min-width: 760px) {
            width: 60% !important;
            height: 100% !important;
            margin-right: 0% !important;
        }

        @keyframes algo {
            from { width: 80% }
            to { width: 100% }
        }
    }
    .container-image {
        position: absolute;
        width: 100%;
        height: 52%;
        top: 10%;
        
        .image {
            position: relative;
            // background-image: url(~@/assets/images/bg.jpg);
            background-size: cover;
            background-repeat: no-repeat;
            width: 80%;
            height: 100%;
            margin: 0% auto;
            overflow: hidden;

            .bg-red {
                position: absolute;
                // width: 100%;
                height: 100%;
                background-color: $main-red-1;
            }
        }

        @media (min-width: 760px) {
            width: 50%;
            right: 0;
            margin-right: 5%;
            height: 80%;
            .image { width: 100% }
        }

        @media (min-width: 1900px) {
            height: 75%;
            top: 13%;
            width: 53%;
        }
    }
}

</style>